<template>
    <v-container fluid>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="12" lg="10" xl="6">
                <PatientTable/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import PatientTable from "../components/patient/PatientTable";

    export default {
        components: {
            PatientTable
        },
        data: () => ({}),
    }
</script>
